module.exports = "/_next/static/images/heartinhand-line-81a0525bcd7facbe9c98613b37222ef6.svg";